"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
var Base_1 = require("../Base");
exports.Wrapper = Base_1.BaseTextarea;
